/**
 * Teil 3 picture-card image hosting.
 *
 * Images live in Cloudflare R2 (not the repo). The DB stores the FILENAME ONLY;
 * the location is owned here via REACT_APP_TEIL3_BASE_PATH (e.g.
 * "https://<bucket>.r2.dev/teil3/" or "https://cdn.auraspeak.in/teil3/").
 * If files ever move, change the env in one place and nothing else breaks.
 *
 * Local dev falls back to the static /teil3/ folder.
 */
const TEIL3_BASE = (process.env.REACT_APP_TEIL3_BASE_PATH || '/teil3/').replace(/\/?$/, '/');

export function teil3ImageUrl(filename: string): string {
  return filename ? `${TEIL3_BASE}${filename}` : '';
}
